<template>
    <section class="content">
        <div class="container-fluid" >
        

            <div class="row clearfix" style="margin-top:10px">
               

                <div :class="{ 'col-md-4': user.role_id == 1, 'col-md-6': user.role_id > 1 }">
                    
                    <div class="info-box bg-amber hover-expand-effect" >
                        <div class="icon">
                            <i class="material-icons">shopping_cart</i>
                        </div>
                        <div class="content">
                            <div class="text" >จำนวนสั่งซื้อ(วัน)</div>
                            <div class="number" >{{ total_amount_day | comma }}</div>
                        </div>
                    </div>
                </div>

                <div :class="{ 'col-md-4': user.role_id == 1, 'col-md-6': user.role_id > 1 }">
                    <div class="info-box bg-orange hover-expand-effect">
                        <div class="icon">
                            <i class="material-icons">attach_money</i>
                        </div>
                        <div class="content">
                            <div class="text" >ราคารวม(วัน)</div>
                            <div class="number" >{{ total_price_day | comma2 }}</div>
                        </div>
                    </div>
                </div>
                 <div class="col-md-4" v-if="user.role_id == 1">
                    <div class="info-box bg-deep-orange hover-expand-effect">
                        <div class="icon">
                            <i class="material-icons">equalizer</i>
                        </div>
                        <div class="content">
                            <div class="text">กำไร(วัน)</div>
                            <div class="number">{{ total_profit_day | comma2 }}</div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row clearfix" style="margin-top:10px">
               

                <div :class="{ 'col-md-4': user.role_id == 1, 'col-md-6': user.role_id > 1 }">
                   
                   <div class="info-box bg-cyan hover-expand-effect" >
                       <div class="icon">
                           <i class="material-icons">shopping_cart</i>
                       </div>
                       <div class="content">
                           <div class="text" >จำนวนสั่งซื้อ(เดือน)</div>
                           <div class="number" >{{ total_amount_month | comma }}</div>
                       </div>
                   </div>
               </div>

               <div :class="{ 'col-md-4': user.role_id == 1, 'col-md-6': user.role_id > 1 }">
                   <div class="info-box bg-light-blue hover-expand-effect">
                       <div class="icon">
                           <i class="material-icons">attach_money</i>
                       </div>
                       <div class="content">
                           <div class="text" >ราคารวม(เดือน)</div>
                           <div class="number">{{ total_price_month | comma2 }}</div>
                       </div>
                   </div>
               </div>
                <div class="col-md-4" v-if="user.role_id == 1">
                   <div class="info-box bg-blue hover-expand-effect">
                         <div class="icon">
                            <i class="material-icons">equalizer</i>
                        </div>
                       <div class="content">
                           <div class="text">กำไร(เดือน)</div>
                           <div class="number">{{ total_profit_month | comma2 }}</div>
                       </div>
                   </div>
               </div>
           </div>

           <div class="row clearfix" style="margin-top:10px">
               

                <div :class="{ 'col-md-4': user.role_id == 1, 'col-md-6': user.role_id > 1 }">
                   
                   <div class="info-box bg-light-green hover-expand-effect" >
                       <div class="icon">
                           <i class="material-icons">shopping_cart</i>
                       </div>
                       <div class="content">
                           <div class="text" >จำนวนสั่งซื้อ(ปี)</div>
                           <div class="number">{{ total_amount | comma }}</div>
                       </div>
                   </div>
               </div>

               <div :class="{ 'col-md-4': user.role_id == 1, 'col-md-6': user.role_id > 1 }">
                   <div class="info-box bg-green hover-expand-effect">
                       <div class="icon">
                           <i class="material-icons">attach_money</i>
                       </div>
                       <div class="content">
                           <div class="text" >ราคารวม(ปี)</div>
                           <div class="number" >{{ total_price | comma2 }}</div>
                       </div>
                   </div>
               </div>
                <div class="col-md-4" v-if="user.role_id == 1">
                   <div class="info-box bg-teal hover-expand-effect">
                        <div class="icon">
                            <i class="material-icons">equalizer</i>
                        </div>
                       <div class="content">
                           <div class="text">กำไร(ปี)</div>
                           <div class="number">{{ total_profit | comma2 }}</div>
                       </div>
                   </div>
               </div>
           </div>
        
             <div class="row clearfix" >
               
                <div class="col-sm-6">
                    <div class="card">
                       
                           <div id="chart-1" style="width: 100%; height: 450px;"></div>
                        
                    </div>
                </div>

                <div class="col-sm-6">
                    <div class="card">
                         
                           <div id="chart-2" style="width: 100%; height: 450px;"></div>
                        
                    </div>
                </div>

            </div>

     
    
        </div>
    </section>
</template>

<script>
google.charts.load('current', {'packages':['corechart','bar']});
import { DashboardService } from '../../service'
import helper from '../../classes/helper'
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';


export default {
    name : "Dashboard",
    components: {
        DatePicker
    },
    data(){
        return {
            user:JSON.parse(localStorage.getItem('user')),
            amounts:[],
            prices: [],
            total_amount_day: 0,
            total_price_day: 0,
            total_profit_day: 0,
            total_amount_month: 0,
            total_price_month: 0,
            total_profit_month: 0,
            total_amount: 0,
            total_price: 0,
            total_profit: 0,
            loading: true,
        
        }
    },
    async created() {
        let userStorage = localStorage.getItem('user')
        let user = null
        if(userStorage){
             user = JSON.parse(userStorage)
        }
       
        if(!user){
            this.$router.push('/login')
            
        }

        this.drawChart()
     
        //google.charts.setOnLoadCallback(this.drawChart)
    },
    watch:{
       
    },
    mounted(){
        //this.initCharts()
    },
    methods: {
        async drawChart() {
            let response = await DashboardService.get()
            console.log(response)
            this.total_amount_day = response.total_amount_day
            this.total_price_day = response.total_price_day
            this.total_profit_day = response.total_profit_day
            this.total_amount_month = response.total_amount_month
            this.total_price_month = response.total_price_month
            this.total_profit_month = response.total_profit_month
            this.total_amount = response.total_amount
            this.total_price = response.total_price
            this.total_profit = response.total_profit
            //this.drawChart1(response.amounts)
            //this.drawChart2(response.prices)
        },
        // drawChart1(amounts) {
            
        //     var data = google.visualization.arrayToDataTable([
        //         ["Month", "Amount", { role: "style" } ],
        //         ['Jan', amounts[0], '#36A2EB'],
        //         ['Feb', amounts[1], '#cc65fe'],
        //         ['Mar', amounts[2], '#4BC0C0'],
        //         ['Apr', amounts[3],'#FFCD56'],
        //         ['May', amounts[4],'#FF6384'],
        //         ['Jun', amounts[5],'#3C5B6F'],
        //         ['Jul', amounts[6],'#A79277'],
        //         ['Aug', amounts[7],'#40679E'],
        //         ['Sep', amounts[8],'#673AB7'],
        //         ['Oct', amounts[9],'#FF5722'],
        //         ['Nov', amounts[10],'#FFEB3B'],
        //         ['Dec', amounts[11],'#3F51B5']
        //     ]);

        //     var view = new google.visualization.DataView(data);
        //         view.setColumns([0, 1,
        //             { calc: "stringify",
        //                 sourceColumn: 1,
        //                 type: "string",
        //                 role: "annotation" },
        //          2]);

        //         var options = {
        //             title: "จำนวนสั่งซื้อ(ครั้ง)",
        //             legend: { position: "none" },
        //         };
        //         var chart = new google.visualization.ColumnChart(document.getElementById("chart-1"));
        //         chart.draw(view, options);
        // },
        // drawChart2(prices) {
        //     let bgs = ['#36A2EB','#cc65fe','#4BC0C0','#FF9F40','#FFCD56','#FF6384','#3C5B6F','#A79277','#40679E']
        //     var data = google.visualization.arrayToDataTable([
        //     ["Month", "Amount", { role: "style" } ],
        //     ['Jan', prices[0], '#36A2EB'],
        //         ['Feb', prices[1], '#cc65fe'],
        //         ['Mar', prices[2], '#4BC0C0'],
        //         ['Apr', prices[3],'#FFCD56'],
        //         ['May', prices[4],'#FF6384'],
        //         ['Jun', prices[5],'#3C5B6F'],
        //         ['Jul', prices[6],'#A79277'],
        //         ['Aug', prices[7],'#40679E'],
        //         ['Sep', prices[8],'#673AB7'],
        //         ['Oct', prices[9],'#FF5722'],
        //         ['Nov', prices[10],'#FFEB3B'],
        //         ['Dec', prices[11],'#3F51B5']
        // ]);

        //     var view = new google.visualization.DataView(data);
        //     view.setColumns([0, 1,
        //          { calc: "stringify",
        //            sourceColumn: 1,
        //            type: "string",
        //            role: "annotation" },
        //          2]);

        //     var options = {
        //      title: "ราคารวม/เดือน",
        //     legend: { position: "none" },
        //     };
        //     var chart = new google.visualization.ColumnChart(document.getElementById("chart-2"));
        //     chart.draw(view, options);
        // },
//         initCharts() {
//     //Chart Bar
//     $('.chart.chart-bar').sparkline(undefined, {
//         type: 'bar',
//         barColor: '#fff',
//         negBarColor: '#fff',
//         barWidth: '4px',
//         height: '34px'
//     });

//     //Chart Pie
//     $('.chart.chart-pie').sparkline(undefined, {
//         type: 'pie',
//         height: '50px',
//         sliceColors: ['rgba(255,255,255,0.70)', 'rgba(255,255,255,0.85)', 'rgba(255,255,255,0.95)', 'rgba(255,255,255,1)']
//     });

//     //Chart Line
//     $('.chart.chart-line').sparkline(undefined, {
//         type: 'line',
//         width: '60px',
//         height: '45px',
//         lineColor: '#fff',
//         lineWidth: 1.3,
//         fillColor: 'rgba(0,0,0,0)',
//         spotColor: 'rgba(255,255,255,0.40)',
//         maxSpotColor: 'rgba(255,255,255,0.40)',
//         minSpotColor: 'rgba(255,255,255,0.40)',
//         spotRadius: 3,
//         highlightSpotColor: '#fff'
//     });
// },
    },
    filters:{
        convertDate(value){
             return helper.Date(value)
        },
        comma(value) {
            return helper.WithComma(value)
        },
        comma2(value) {
            return helper.WithComma(value, 2)
        },
        
    }
}


</script>

<style scoped>


.number{
    text-align: left;
}
</style>


// WEBPACK FOOTER //
// src/components/Dashboard/Dashboard.vue